import { useFormikContext } from 'formik';

import { ErrorField } from '@/components/error-field';
import { RequiredLabel } from '@/components/required-label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import { useFetchAllPhoneNumberQuery } from '@/query/phone-number.query';

import type { BatchCallFormValues } from '@/schemas/batch-call.schema';

import { useFormikError } from '@/lib/error';

export const FromNumberField = () => {
  const { values, setFieldValue } = useFormikContext<BatchCallFormValues>();
  const hasError = useFormikError();

  const { data } = useFetchAllPhoneNumberQuery({
    is_associated: true,
  });

  const phoneNumbers = data?.data || [];

  return (
    <div className="space-y-2">
      <RequiredLabel>From Number</RequiredLabel>
      <Select value={values.agentId} onValueChange={value => setFieldValue('agentId', value)}>
        <SelectTrigger
          id="agentId"
          className="border-zinc-200 w-full"
          aria-invalid={hasError('agentId')}
        >
          <SelectValue placeholder="Select a phone number" />
        </SelectTrigger>
        <SelectContent>
          {phoneNumbers.length === 0 ? (
            <div className="py-2 text-center text-sm text-muted-foreground">
              No phone numbers available
            </div>
          ) : (
            phoneNumbers.map(phoneNumber => (
              <SelectItem key={phoneNumber.id} value={phoneNumber.agent.id.toString()}>
                {phoneNumber.agent?.agent_name} - {phoneNumber.phone_number}
              </SelectItem>
            ))
          )}
        </SelectContent>
      </Select>
      <ErrorField name="agentId" />
    </div>
  );
};
